import { useForm } from 'react-hook-form';
import styled from 'styled-components';
import { JoinInput } from '../../../components/items/joinInput';
import { Button } from '../../../components/items/Button';
import { CommonTitle } from '../../../components/items/common.title';
import { useState } from 'react';
import {
  cancelDelegation,
  fetchDelegationData,
  setDelegation,
} from '../../../api/mypage';
import { zodResolver } from '@hookform/resolvers/zod';
import { searchItemSchema } from '../../../schema/mypageSchema';
import { AlertModal } from '../../../components/modal/alert.modal';
import { useHistory } from 'react-router-dom';

interface VehicleData {
  id: number;
  vehicle: string;
}

interface SearchItemProps {
  searchItem: string;
}

interface DelegationProps {
  radioBtnItems?: string; // 선택된 라디오 버튼의 ID
}

const UserDelegationChange = () => {
  // 검색 필드를 위한 useForm
  const {
    register: searchRegister,
    handleSubmit: handleSearchSubmit,
    getValues,
    formState: { errors: searchErrors },
  } = useForm<SearchItemProps>({
    resolver: zodResolver(searchItemSchema),
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const { handleSubmit: handleDelegationSubmit } = useForm<DelegationProps>();
  const [radioBtnItems, setRadioBtnItems] = useState<VehicleData[]>([]);
  const [selectedId, setSelectedId] = useState<number | null>(null);
  const [navigateOnClose, setNavigateOnClose] = useState(false); // 페이지 이동 여부를 추적
  const [errorMessage, setErrorMessage] = useState('');
  const history = useHistory(); // useHistory 훅 사용

  const onSearchSubmit = async () => {
    const searchValue = getValues('searchItem'); // 검색어를 가져옴
    try {
      const result = await fetchDelegationData(searchValue);

      setRadioBtnItems(result);

      if (result.length === 0) {
        setErrorMessage('아이디가 존재하지 않습니다.');
      } else {
        setErrorMessage('');
      }
    } catch (error) {
      setErrorMessage('데이터를 불러오는 중 오류가 발생했습니다.');
    }
  };

  const onDelegationSubmit = async () => {
    if (selectedId === null) {
      try {
        const response = await cancelDelegation();
        setModalMessage(response.message);
        setNavigateOnClose(true);
      } catch (error) {
        console.error('위임 권한 취소 중 오류가 발생했습니다:', error);
        setModalMessage('위임 권한 취소 중 오류가 발생했습니다.');
        setNavigateOnClose(false);
      } finally {
        setIsModalOpen(true);
      }
    } else if (selectedId !== null) {
      try {
        const response = await setDelegation(selectedId);
        setModalMessage(response.message); // 성공 메시지 출력
        setNavigateOnClose(true); // 비밀번호 변경이 성공하면 페이지 이동 설정
      } catch (error) {
        console.error('위임 권한 설정 중 오류가 발생했습니다:', error);
        setModalMessage('위임 권한 취소 후 설정해주세요.');
        setNavigateOnClose(false); // 오류 발생 시 페이지 이동을 하지 않도록 설정
      } finally {
        setIsModalOpen(true);
      }
    } else {
      setErrorMessage('차량을 선택해주세요.');
    }
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    if (navigateOnClose) {
      history.push({
        pathname: '/mypage',
      }); // navigateOnClose가 true일 때만 /mypage로 이동
    }
  };

  // // 검색을 한 대상만 불러옴. 전체 데이터 불러오기
  // useEffect(() => {
  //   // 컴포넌트가 마운트될 때 handleSearch 함수 호출
  //   handleSearchSubmit(onSearchSubmit)(); // 컴포넌트가 마운트될 때 검색 수행
  //   console.log('radioBtnItems 상태:', radioBtnItems);
  // }, []); // 빈 배열을 전달하여 컴포넌트가 마운트될 때 한 번만 실행

  return (
    <Container>
      <CommonTitle title="위임 회원 검색" />
      <form onSubmit={handleSearchSubmit(onSearchSubmit)}>
        <JoinInput
          name="searchItem"
          label="회원 검색"
          btn
          btnTitle="검색"
          placeholder="아이디 검색"
          errors={
            searchErrors.searchItem?.message
              ? [searchErrors.searchItem.message as string]
              : []
          }
          onClick={handleSearchSubmit(onSearchSubmit)}
          register={searchRegister}
        />
      </form>
      <form
        className="delegation-form"
        onSubmit={handleDelegationSubmit(onDelegationSubmit)}
      >
        <div className="setting-wrap">
          <ul className="id-search-box">
            {radioBtnItems.map((item, i) => (
              <li key={item.id}>
                <div className="radio-box">
                  <label className="text" htmlFor={item.id.toString()}>
                    {item.vehicle}
                  </label>
                  <input
                    type="radio"
                    value={item.id}
                    id={item.id.toString()}
                    checked={selectedId === item.id}
                    onChange={() => setSelectedId(item.id)} // 선택된 ID 설정
                  />
                  <label
                    className="check-box"
                    htmlFor={item.id.toString()}
                  ></label>
                </div>
              </li>
            ))}
          </ul>
          {/* <div className="no-delegation">
            <div className="radio-box">
              <input
                type="radio"
                id="noDelegation"
                checked={selectedId === null}
                onChange={() => setSelectedId(null)} // "위임하지 않음"을 선택하면 null로 설정
              />
              <label className="check-box" htmlFor="noDelegation"></label>
              <label className="text" htmlFor="noDelegation">
                위임하지 않음
              </label>
            </div>
          </div> */}
        </div>
        <Button title="저 장" type="submit" fiexd />
      </form>
      {isModalOpen && (
        <AlertModal
          handleConfirmClose={handleModalClose}
          confirmText={modalMessage}
          onClick={handleModalClose}
        />
      )}
    </Container>
  );
};

export default UserDelegationChange;

// style
const Container = styled.div`
  height: 100%;
  padding: 2.4rem 2rem;
  form.delegation-form {
    margin-top: 1rem;
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
    height: 100%;
    padding-bottom: 3rem;
    overflow: scroll;
    max-height: calc(100% - 22rem);
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, Opera*/
    }
    .setting-wrap {
      display: flex;
      flex-direction: column;
      gap: 1.6rem;
      height: calc(100% - 16rem);
      .inner-box {
        button {
          padding-left: 2rem;
          padding-right: 2rem;
        }
      }
      .id-search-box {
        display: flex;
        flex-direction: column;
        width: 100%;
        li {
          width: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid ${(props) => props.theme.gray300};
          .radio-box {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 1.3rem 0.8rem;
            position: relative;
            input[type='radio'] {
              display: none;
            }
            label.text {
              font-size: 1.6rem;
              font-weight: 600;
              color: #555;
            }
            label.check-box {
              &::after {
                content: '';
                width: 2.2rem;
                height: 2.2rem;
                position: absolute;
                right: 0.8rem;
                top: 50%;
                transform: translateY(-50%);
                width: 2.2rem;
                height: 2.2rem;
                border-radius: 2.2rem;
                background: url('/assets/checkbox-nofill.svg');
                background-size: cover;
                background-position: center center;
                background-repeat: no-repeat;
              }
            }
            input[type='radio']:checked + label.check-box {
              &::after {
                background: url('/assets/checkbox-checked22px.svg');
                background-size: cover;
                background-position: center center;
                background-repeat: no-repeat;
              }
            }
          }
        }
      }
    }
    .no-delegation {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .radio-box {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 1.3rem 0.8rem;
        position: relative;
        input[type='radio'] {
          display: none;
        }
        label.text {
          font-size: 1.3rem;
          font-weight: 600;
          color: #555;
          padding-left: 3rem;
        }
        label.check-box {
          &::after {
            content: '';
            width: 2.2rem;
            height: 2.2rem;
            position: absolute;
            left: 1rem;
            top: 50%;
            transform: translateY(-50%);
            width: 2.2rem;
            height: 2.2rem;
            border-radius: 2.2rem;
            background: url('/assets/checkbox-nofill.svg');
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;
          }
        }
        input[type='radio']:checked + label.check-box {
          &::after {
            background: url('/assets/checkbox-checked22px.svg');
            background-size: cover;
            background-position: center center;
            background-repeat: no-repeat;
          }
        }
      }
    }
  }
`;
